import { render, staticRenderFns } from "./SubscriptionWelcomePage.vue?vue&type=template&id=29d8e877&scoped=true"
import script from "./SubscriptionWelcomePage.vue?vue&type=script&lang=js"
export * from "./SubscriptionWelcomePage.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionWelcomePage.vue?vue&type=style&index=0&id=29d8e877&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d8e877",
  null
  
)

export default component.exports